import type { ReactNode, SVGProps } from "react";

export function SuccessIcon(props: SVGProps<SVGSVGElement>): ReactNode {
	return (
		<svg
			fill="none"
			height="6"
			viewBox="0 0 8 6"
			width="8"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M7.5 0.5L2.6 5.5L0.5 3.625"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
